import React, { useState, useEffect } from 'react';
// Исправляем путь импорта
import SectionTasks from "../components/SectionTasks/SectionTasks";

export default function Tasks() {
    const [screenSize, setScreenSize] = useState({
        isMobile: false,
        isSmallMobile: false
    });
    
    useEffect(() => {
        // Функция для проверки размера экрана
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setScreenSize({
                isMobile: width <= 768,
                isSmallMobile: width <= 480
            });
        };
        
        // Проверяем при первой загрузке
        checkScreenSize();
        
        // Добавляем слушатель изменения размера экрана
        window.addEventListener('resize', checkScreenSize);
        
        // Убираем слушатель при размонтировании компонента
        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, []);
    
    // Определяем отступ в зависимости от размера экрана - минимальные значения
    const getPaddingTop = () => {
        if (screenSize.isSmallMobile) return '40px';
        if (screenSize.isMobile) return '50px';
        return '70px';
    };
    
    // Получаем значение отрицательного отступа сверху для всей страницы
    const getMarginTop = () => {
        if (screenSize.isSmallMobile) return '-110px';
        if (screenSize.isMobile) return '-130px';
        return '-150px';
    };
    
    // Минимальная высота страницы должна быть равна высоте экрана минус высота хедера
    const getMinHeight = () => {
        if (screenSize.isSmallMobile) return 'calc(100vh - 60px)';
        if (screenSize.isMobile) return 'calc(100vh - 70px)';
        return 'calc(100vh - 80px)';
    };
    
    return (
        <main className="page" style={{ 
            paddingTop: getPaddingTop(),
            marginTop: getMarginTop(),
            minHeight: getMinHeight()
        }}>
            <SectionTasks />
        </main>
    )
} 